export default __webpack_public_path__ + "static/media/basil-singer.883d13f3.jpg";